import styles from "./FamilyGroupCardBorderless.module.css";

interface FamilyGroupCardBorderless {
    children: React.ReactNode;
}

export const FamilyGroupCardBorderless = ( {children}: FamilyGroupCardBorderless ) => {
  return (
    <div className={styles.card}>
        {children}
    </div>
  )
}
